import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-ml-2 p-p-2 p-component" }
const _hoisted_2 = { class: "header p-component" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "p-pt-2 content" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, "SQUEEZE " + _toDisplayString(_ctx.$t('Squeeze.System.ApiDocumentation')), 1),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.System.ApiDocumentationHelpText')) + " ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("a", {
        href: "https://discuss.dexpro-solutions.de/",
        target: "_blank"
      }, "https://discuss.dexpro-solutions.de/", -1))
    ]),
    _createElementVNode("a", {
      class: "urlText",
      href: _ctx.squeezeBasePath + '/dist/',
      target: "_blank"
    }, _toDisplayString(_ctx.$t('Squeeze.System.LinkApiDocumentation')), 9, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("iframe", {
        src: _ctx.squeezeBasePath + '/dist/',
        width: "100%",
        height: "100%",
        name: "SQUEEZE API Documentation",
        title: "SQUEEZE API Documentation"
      }, null, 8, _hoisted_5)
    ])
  ]))
}